import { render, staticRenderFns } from "./gap.vue?vue&type=template&id=1c7fa2ba&scoped=true&"
import script from "./gap.vue?vue&type=script&lang=js&"
export * from "./gap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7fa2ba",
  null
  
)

export default component.exports